import React, {} from 'react';
import { View, Text } from 'react-native';

import { ColumnContainer, LeftContainer, RightContainer } from '../elements';
import UpcomingAssets from './Assets/Upcoming';
import UpcomingSales from './Sales/upcoming';

const Home = () => {
  return (
    <ColumnContainer>
      <LeftContainer>
        <UpcomingSales />
      </LeftContainer>
      <RightContainer>
        <UpcomingAssets />
      </RightContainer>
    </ColumnContainer>
  )
}

export default Home;
